import http from '../http'
/**
 * 重启系统服务
 */
export const putHost = () => {
    return http.put('/api/host')
}
/**
 * 获取服务器环境
 */
export const getEnvironment = () => {
    return http.get('/api/host/environment')
}
/**
 * 获取服务配置
 */
export const getSetting = () => {
    return http.get('/api/host/setting')
}
/**
 * 修改服务配置
 * @param {object} setting 配置信息, 例: {
    cors: {
        origins: 'https://localhost',
        methods: '*',
        headers: '*',
        exposedHeaders: 'www-authenticate'
    },
    user: {
        passwordLifetime: 90,
        loginErrorLimit: 5,
        loginErrorTime: 15,
        loginIPLimit:
            '127.0.0.1-127.0.0.254\n192.168.0.1-192.168.0.254\n192.168.1.1-192.168.1.254'
    }
}
*/
export const putSetting = setting => {
    return http.put('/api/host/setting', setting)
}



// WEBPACK FOOTER //
// ./src/api/main/api-host.js